/**
 * NolaCoin GraphQL API 型定義
 *
 * getWalletクエリで取得するコイン残高情報の型定義
 */

/**
 * ウォレット情報
 * getWalletクエリのレスポンス型
 */
export interface Wallet {
  /** ユーザーID */
  userId: string;
  /** 現在の使用可能残高（Fish残高として使用） */
  amount: number;
  /** 総残高（履歴情報含む） */
  totalAmount: number;
  /** 残高の内訳詳細 */
  walletBreakdown: WalletBreakdown[];
}

/**
 * ウォレット残高内訳
 */
export interface WalletBreakdown {
  /** コインの種類 */
  coinType: CoinType;
  /** 該当タイプの残高 */
  amount: number;
}

/**
 * コインタイプ列挙
 */
export enum CoinType {
  /** 基本コイン */
  BASE = "BASE",
  /** プリペイドコイン */
  PREPAID = "PREPAID",
}
